import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from '@material-ui/icons/Add';
import {getConnections, getConnectionsForUser, setConnectionsForUser, setSelectedOption} from '../../actions/session'
import _ from 'lodash';
import Button from "@material-ui/core/Button";
import ConnectionCard from "../../components/ConnectionCard";
import {theme} from "../Dashboard/theme";
import Grid from "@material-ui/core/Grid";
import ViewTitle from "../../components/ViewTitle";
import Link from "@material-ui/core/Link";
import {Link as RouterLink} from "react-router-dom";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Box from "@material-ui/core/Box";

const styles = theme => ({

  addIcon: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAllign: 'center',
    color: theme.palette.text.secondary,
    maxWidth: 936,
    margin: 'auto',
    overflow: 'shown',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    paddingTop: '12px'
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});

let themeCustom = {
  ...theme,
};

class Query extends React.Component {

  state = {
    open: true
  };

  componentDidMount() {
    this.props.getConnections();
    this.props.getConnectionsForUser(this.props.session.userId);
  }

  handleSelection = (option) => {
    this.props.setSelectedOption(option);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.setConnectionsForUser(this.props.session.userId, this.props.session.selectedOption.id)
  };

  handleClose = () => {
    this.setState({open: false})
  };

  handleOpen = () => {
    this.setState({open: 'open'})
  };

  renderCards = (connections) => {
    if (!_.isEmpty(connections)) {
      return connections.map(conn => {
        return <ConnectionCard key={conn._id} connection={conn}/>
      })
    } else {
      return null
    }
  };

  render() {
    const {classes, session} = this.props;

    return (
      <ThemeProvider theme={themeCustom}>
        <ViewTitle>
          Search Database
        </ViewTitle>
        <Grid container spacing={2} xs={12} direction="row" justify="center">
          <Grid item container justify="center" xs={12}>
            <form onSubmit={this.handleSubmit}>
              <Autocomplete
                options={session.connections ? session.connections : []}
                getOptionLabel={option => option.physicalIssue}
                style={{width: '250px'}}
                label="Standard"
                onChange={(event, option) => this.handleSelection(option)}
                renderInput={params => (
                  <TextField {...params}
                             variant="outlined"
                             noValidate
                             label="Select an ailment"
                             style={{width: '250px'}}
                  />
                )}
              />
            </form>
            <Button onClick={this.handleSubmit}
                    variant="contained" type="submit" color="primary" aria-label="add" style={{marginLeft: "16px"}}>
              <AddIcon/>
            </Button>
          </Grid>
          <Grid item xs={12} container justify="flex-start">
            <Grid item xs={5}/>
            <Grid item>
              <Link component={RouterLink} to="/dashboard/query/connectionRequest" variant="body2">
                Ailment not listed?
              </Link>
            </Grid>
            <Grid item xs={5}/>
          </Grid>
        </Grid>
        {
          !_.isEmpty(this.props.session.userConnections) ?
            <Paper className={classes.paper} style={{marginTop: '20px'}}>
              {this.renderCards(this.props.session.userConnections)}
            </Paper>
            :
            null
        }
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll='paper'
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Please Read:</DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              // ref={descriptionElementRef}
              tabIndex={-1}
            >
              <Typography variant="body1">
                <Typography display="inline"><Box display="inline" fontWeight="fontWeightBold">Please be sure to read
                  through the definition carefully.</Box></Typography> As you read the information below for each
                specific ailment you have chosen, you will want to keep an open mind and not be in your head but really
                notice how you have been feeling emotionally towards the past/present/future. Emotions can feel tricky
                at times. Even if you “negate" them they can still be in your subconscious mind.
              </Typography>
              <br/>
              <Typography display="inline"><Box fontWeight="fontWeightBold">There are a few things you
                will want to keep in mind as you read through the description. </Box>
              </Typography>
              <br/>
              <Typography variant="body1">
                First, please remember to be gentle, loving, kind and supportive to yourself. Remember that if you find
                a pattern that you are not “fond” of, do not criticize or judge yourself. That will not help. Instead,
                remember that we all have things that we are working on and that, obviously, you did not intentionally
                put the programming in your mind. In many cases, these patterns can start in childhood. So, instead of
                judging or criticizing yourself, you will simply want to support yourself to embody authentic change
                because you do deserve a healthy, happy, harmonious and loving life!
              </Typography>
              <br/>
              <Typography variant="body1">
                Secondly, you will see that I have provided the common emotional links that I have found connected to
                this specific ailment. It is important to note that you may or may not resonate with every single
                thought pattern/emotion. You may only resonate with part of it or certain parts. Each person can be
                slightly different depending upon their symptoms. And each ailment can have a variety of different
                symptoms. For example: with menstrual issues, one woman may experience cramping while another suffers
                from lower back pain while another person has headaches. Each person can be different. This is true with
                each ailment. So, please read through the entire ailment and note which parts apply to you and simply
                ignore the rest.
              </Typography>
              <br/>
              <Typography variant="body1">
                <Typography display="inline"><Box display="inline" fontWeight="fontWeightBold">To
                  do:</Box></Typography> what you will want to do is read through the description and write down any of
                the words/thought
                patterns/emotions that you resonate with. If you notice any feeling that is close to what you are
                feeling, for example if the definition says the emotion is feeling “rage” and you don’t feel like you
                have a lot of rage but you do have anger patterns, please do write that down because sometimes we can
                use different words to describe the same feeling.
              </Typography>
              <br/>
              <Typography variant="body1">
                And again, please keep in mind that likely there will be some things listed in the description that you
                may not resonate with. That’s normal. Likely there will be some that do not pertain to you, or, in some
                cases, there are things that are suppressed in your subconscious mind that you can't yet see. That’s ok!
                Once you begin working with creating the shifts and working with the tools to clear your mind, you will
                want to come back and reread the ailment description and make sure that you fully made the authentic
                change, and see if there's any other pieces that need to be shifted.
              </Typography>
              <br/>
              <Typography variant="body1">
                Lastly, after you write down the specific emotions, it is important *not* to dive into the negative.
                That could make you feel worse, not better. Instead, you will first want to make sure to bring in the
                positive first, and make sure that you are really feeling it (we will be doing this in the upcoming
                steps). This is key. Also, remember what we have discussed previously, that if your brain has a new
                replacement, it will be easier to let go of the old. After you bring in the positive emotions, then we
                will work on releasing the negative and also focus on the deserving gateway to help you free yourself
                from negativity and allow your body to heal itself!
              </Typography>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Accept
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };
}

Query.propTypes = {
  classes: PropTypes.object.isRequired,
};

Query = withStyles(styles)(Query);

const mapStatetoProps = (state) => {
  return {
    ...state
  }
};

Query = connect(
  mapStatetoProps, {
    getConnections,
    getConnectionsForUser,
    setSelectedOption,
    setConnectionsForUser
  }
)(Query);


export default Query;
